export default class LinkRenderer {
  // init method gets the details of the cell to be rendered
  init(params) {
    this.eGui = document.createElement("span")
    this.eGui.innerHTML = params.value || ""
  }

  getGui() {
    return this.eGui
  }

  refresh() {
    return false
  }
}
